export default __webpack_public_path__ + "static/media/151-ladders.2aaddce3.png";